// Overlay.js
import React, { useRef } from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from './Overlay.module.css';
import close from '../../../styles/shared/CloseButton.module.css';

const Overlay = ({ message, onClose, showConfirmation, onConfirm }) => {
    const overlayRef = useRef();

    const handleClickOutside = (e) => {
        if (overlayRef.current && !overlayRef.current.contains(e.target)) {
            onClose();
        }
    };

    return (
        <div className={styles.overlay} onClick={handleClickOutside}>
            <div className={styles.container} ref={overlayRef}>
                <div>{message}</div>
                {showConfirmation && (
                    <div className={styles.buttons}>
                        <button onClick={onConfirm}>Si</button>
                        <button onClick={onClose}>No</button>
                    </div>
                )}
                {!showConfirmation && (
                    <button className={close.closeButton} onClick={onClose}>
                        <FaTimes />
                    </button>
                )}
            </div>
        </div>
    );
};

export default Overlay;

